import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Header from "./components/Header";
import Dashboard from "./pages/Dashboard";
import Coders from "./pages/Coders";
import Supervisors from "./pages/Supervisors";
import Games from "./pages/Games";
import Contracts from "./pages/Contracts";
import Enterprises from "./pages/Enterprises";
import Codings from "./pages/Codings";
import Supervisions from "./pages/Supervisions";
import Changes from "./pages/Changes";
import SyncLogs from "./pages/SyncLogs";
import Reports from "./pages/Reports";
import { ChangesProvider } from "./contexts/ChangesContext";
import "./App.css";

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ChangesProvider>
        <div className="App">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/coders" element={<Coders />} />
              <Route path="/supervisors" element={<Supervisors />} />
              <Route path="/games" element={<Games />} />
              <Route path="/codings" element={<Codings />} />
              <Route path="/supervisions" element={<Supervisions />} />
              <Route path="/changes" element={<Changes />} />
              <Route path="/enterprises" element={<Enterprises />} />
              <Route path="/contracts" element={<Contracts />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/sync-logs" element={<SyncLogs />} />
            </Routes>
          </main>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
          />
        </div>
      </ChangesProvider>
    </Router>
  );
}

export default App;
